// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `body {
  font-family: "Ysabeau Office", sans-serif;
  font-style: normal;
}

.top-header {
  background: #fff; 
  padding: 30px 0;
  display: flex;
  flex-direction: row;
  align-items: center;
  height: 110px;
}

.dropdown-menu.megamenu {
  box-shadow: 0 0 1px 1px rgba(0, 0, 0, 0.05),
    0 7px 9px -4px rgba(0, 0, 0, 0.16), 0 14px 21px 2px rgba(0, 0, 0, 0.1),
    0 5px 26px 4px rgba(0, 0, 0, 0.08);
}

.top-header input.form-control {
  border: 1px solid #ddd;
  font-size: 14px;
  border-radius: 0px;
  min-width: 300px;
  box-shadow: none;
  outline: none;
  position: relative;
  height: 40px;
  line-height: 40px;
  max-width: 300px;
}

.search {
  position: relative;
}

.search i {
  right: 10px;
  top: 11px;
}

.search input.form-control {
  border-radius: 0px;
}

.search-icon i {
  color: #fff;
}

.top-header .navbar-brand {
  margin-right: 50px;
}

.mobile-search {
  padding: 30px;
  box-shadow: 0 0 1px 1px rgba(0, 0, 0, 0.05),
    0 7px 9px -4px rgba(0, 0, 0, 0.16), 0 14px 21px 2px rgba(0, 0, 0, 0.1),
    0 5px 26px 4px rgba(0, 0, 0, 0.08);
  position: relative;
  z-index: 1000;
}

.mobile-search p {
  font-size: 24px;
  line-height: 24px;
  font-weight: 300;
  color: var(--pl-text-color-secondary, #333333);
  margin-top: 0;
  margin-bottom: 24px;
}

.overlay {
  position: fixed;
  top: 300px;
  right: 0;
  left: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
  touch-action: none;
  overflow: hidden;
  display: block;
}

.offcanvas-body a.nav-link {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.offcanvas-body a i {
  font-size: 22px;
  font-weight: bold;
}

.offcanvas-header p {
  margin-left: 23px;
  font-size: 11px;
  margin-top: 9px;
}

.btn-close {
  width: 24px;
  height: 24px;
  box-shadow: none !important;
  outline: none;
  margin-right: 8px;
}

button.btn-close:focus {
  box-shadow: none;
}

.offcanvas {
  max-width: 320px;
}

.offcanvas-body li.nav-item {
  margin-bottom: 2px;
}

.offcanvas-header .btn-close {
  left: 12px;
  top: 20px;
  position: absolute;
}

.form-control:focus {
  box-shadow: none;
  outline: none;
}


footer {
  background-color: #222222;
  padding: 60px 0;
}

footer p {
  color: #fff;
  font-size: 14px;
}

footer .copyright {
  padding: 20px 0 0 0;
  border-top: 1px solid #555454;
  margin-top: 20px;
}


@media (max-width: 280px) {
  .offcanvas,
  #slidingDiv {
    max-width: 265px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/assets/styles/component_style.css"],"names":[],"mappings":"AAAA;EACE,yCAAyC;EACzC,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE;;sCAEoC;AACtC;;AAEA;EACE,sBAAsB;EACtB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;EAChB,aAAa;EACb,kBAAkB;EAClB,YAAY;EACZ,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,SAAS;AACX;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb;;sCAEoC;EACpC,kBAAkB;EAClB,aAAa;AACf;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,gBAAgB;EAChB,8CAA8C;EAC9C,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,UAAU;EACV,QAAQ;EACR,OAAO;EACP,SAAS;EACT,oCAAoC;EACpC,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;EACjB,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,2BAA2B;EAC3B,aAAa;EACb,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,UAAU;EACV,SAAS;EACT,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,aAAa;AACf;;;AAGA;EACE,yBAAyB;EACzB,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,6BAA6B;EAC7B,gBAAgB;AAClB;;;AAGA;EACE;;IAEE,gBAAgB;EAClB;AACF","sourcesContent":["body {\n  font-family: \"Ysabeau Office\", sans-serif;\n  font-style: normal;\n}\n\n.top-header {\n  background: #fff; \n  padding: 30px 0;\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  height: 110px;\n}\n\n.dropdown-menu.megamenu {\n  box-shadow: 0 0 1px 1px rgba(0, 0, 0, 0.05),\n    0 7px 9px -4px rgba(0, 0, 0, 0.16), 0 14px 21px 2px rgba(0, 0, 0, 0.1),\n    0 5px 26px 4px rgba(0, 0, 0, 0.08);\n}\n\n.top-header input.form-control {\n  border: 1px solid #ddd;\n  font-size: 14px;\n  border-radius: 0px;\n  min-width: 300px;\n  box-shadow: none;\n  outline: none;\n  position: relative;\n  height: 40px;\n  line-height: 40px;\n  max-width: 300px;\n}\n\n.search {\n  position: relative;\n}\n\n.search i {\n  right: 10px;\n  top: 11px;\n}\n\n.search input.form-control {\n  border-radius: 0px;\n}\n\n.search-icon i {\n  color: #fff;\n}\n\n.top-header .navbar-brand {\n  margin-right: 50px;\n}\n\n.mobile-search {\n  padding: 30px;\n  box-shadow: 0 0 1px 1px rgba(0, 0, 0, 0.05),\n    0 7px 9px -4px rgba(0, 0, 0, 0.16), 0 14px 21px 2px rgba(0, 0, 0, 0.1),\n    0 5px 26px 4px rgba(0, 0, 0, 0.08);\n  position: relative;\n  z-index: 1000;\n}\n\n.mobile-search p {\n  font-size: 24px;\n  line-height: 24px;\n  font-weight: 300;\n  color: var(--pl-text-color-secondary, #333333);\n  margin-top: 0;\n  margin-bottom: 24px;\n}\n\n.overlay {\n  position: fixed;\n  top: 300px;\n  right: 0;\n  left: 0;\n  bottom: 0;\n  background-color: rgba(0, 0, 0, 0.5);\n  touch-action: none;\n  overflow: hidden;\n  display: block;\n}\n\n.offcanvas-body a.nav-link {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n}\n\n.offcanvas-body a i {\n  font-size: 22px;\n  font-weight: bold;\n}\n\n.offcanvas-header p {\n  margin-left: 23px;\n  font-size: 11px;\n  margin-top: 9px;\n}\n\n.btn-close {\n  width: 24px;\n  height: 24px;\n  box-shadow: none !important;\n  outline: none;\n  margin-right: 8px;\n}\n\nbutton.btn-close:focus {\n  box-shadow: none;\n}\n\n.offcanvas {\n  max-width: 320px;\n}\n\n.offcanvas-body li.nav-item {\n  margin-bottom: 2px;\n}\n\n.offcanvas-header .btn-close {\n  left: 12px;\n  top: 20px;\n  position: absolute;\n}\n\n.form-control:focus {\n  box-shadow: none;\n  outline: none;\n}\n\n\nfooter {\n  background-color: #222222;\n  padding: 60px 0;\n}\n\nfooter p {\n  color: #fff;\n  font-size: 14px;\n}\n\nfooter .copyright {\n  padding: 20px 0 0 0;\n  border-top: 1px solid #555454;\n  margin-top: 20px;\n}\n\n\n@media (max-width: 280px) {\n  .offcanvas,\n  #slidingDiv {\n    max-width: 265px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
